import { Modal, Button, Text, Group } from '@mantine/core';
import { useSelector } from 'react-redux';
import { AppState } from '../../client-redux/reducers';
import { Language } from '../../languages/languageHandler';
import { StatusType } from '../../../libraries/zps';
import { useStatusOperDialog } from '../../context/status-oper-dialog';
import { IconCheck, IconX } from '@tabler/icons-react';

import './styles.scss';
interface ConfirmationModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  text: string;
  successText: string;
  errorText: string;
}

const ConfirmationModal = ({ opened, onClose, onConfirm, text, successText, errorText }: ConfirmationModalProps) => {
  const lang = useSelector<AppState, Language>(state => state.lang.lang);

  const { showStatusOperDialog, handleApiError } = useStatusOperDialog();

  const handleConfirm = async () => {
    onClose();

    try {
      await onConfirm();

      showStatusOperDialog({
        type: StatusType.INFO,
        message: successText
      });
    } catch (error: any) {
      handleApiError(error, errorText);
    }
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      withCloseButton={false}
      centered
      radius="md"
      padding="lg"
      className="confirmation-modal"
      zIndex={11000}
    >
      <Text>{text}</Text>

      <Group style={{ display: 'flex', justifyContent: 'center', gap: '1rem', marginTop: '1rem' }}>
        <Button radius="md" onClick={handleConfirm} leftSection={<IconCheck stroke={2} />} className="yes-button">
          {lang.YES}
        </Button>

        <Button radius="md" onClick={onClose} leftSection={<IconX stroke={2} />} className="no-button">
          {lang.NO}
        </Button>
      </Group>
    </Modal>
  );
};

export default ConfirmationModal;
